__turbopack_context__.v({
  "read-next-card-badge": "ReadNextCard-module___VxJhG__read-next-card-badge",
  "read-next-card-container": "ReadNextCard-module___VxJhG__read-next-card-container",
  "read-next-card-link": "ReadNextCard-module___VxJhG__read-next-card-link",
  "read-next-card-teaser": "ReadNextCard-module___VxJhG__read-next-card-teaser",
  "read-next-card-time": "ReadNextCard-module___VxJhG__read-next-card-time",
  "read-next-card-title": "ReadNextCard-module___VxJhG__read-next-card-title",
});
